import {
  foldersQuery,
  loadFolderTreeQuery,
  folderBreadcrumbQuery,
} from '@/api/folders/graphql/folder.queries';
import { apolloClient } from '@/apollo';
import { IFolder } from '@/folders/types/folder';
import { IFolderTree } from '@/folders/types/folder-tree';
import { EFolderType } from '@/folders/types/enums/folder-type';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class FolderService {
  static async loadFolders(parentFolderId?: string, type?: string): Promise<IFolder[]> {
    const {
      data: { folders = [] },
    } = await apolloClient.query({
      query: foldersQuery,
      variables: {
        parentFolderId,
        type,
      },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return folders;
  }

  static async loadFolderTree(type?: EFolderType): Promise<IFolderTree> {
    const {
      data: { folderTree },
    } = await apolloClient.query({
      query: loadFolderTreeQuery,
      variables: { type },
    });
    return folderTree;
  }

  static async loadBreadcrumbs(parentFolderId?: string, type?: string): Promise<IFolder[]> {
    const {
      data: { folderBreadcrumb },
    } = await apolloClient.query({
      query: folderBreadcrumbQuery,
      variables: { parentFolderId, type },
    });
    return folderBreadcrumb || [];
  }
}
